import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {EmulationModal} from "../../../../../common/emulation-modal/emulation-modal";

export const PromptEmulation = ({warnings=undefined, next}) => cs(
    consumeContext("apis"),

    ["modal", ({}, next) => EmulationModal({
        forceUserLevel: true,
        plugins: warnings?.map((warning) => ({warning})),
        next
    })],

    ({modal}) => next(() => new Promise((resolve, reject) => {
        modal.show(resolve);
    })),
);
